import { Typography } from '@material-ui/core';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

type CardProps = {
	title: string;
	children: ReactNode;
};

const StyledCard = styled.div`
	background-color: #f0f0f0;
	border-radius: 8px;
	padding: 2rem;
`;

const Card = ({ title, children }: CardProps) => {
	return (
		<StyledCard>
			<Typography
				variant="h6"
				style={{
					display: 'inline-block',
					marginLeft: '-2rem',
					marginBottom: '1rem',
					padding: '.5rem 2rem',
					backgroundColor: '#424244',
					color: 'white',
					fontWeight: 800,
				}}
			>
				{title}
			</Typography>
			{children}
		</StyledCard>
	);
};

export default Card;
